import ScriptCenter from "./script-center";

export enum CaptchaBusiness {
  Renderbus,
  Foxrenderfarm,
}

const CaptchaIdMap = new Map([
  [CaptchaBusiness.Renderbus, "2074771113"],
  [CaptchaBusiness.Foxrenderfarm, "2098150990"],
]);
const ThemeColorMap = new Map([
  [CaptchaBusiness.Renderbus, "13CB75"],
  [CaptchaBusiness.Foxrenderfarm, "FB6B4A"],
]);

class Captcha {
  appId: string;
  business: CaptchaBusiness;
  captcha: any;
  TencentCaptcha: any;
  constructor(business: CaptchaBusiness) {
    this.business = business;
    this.appId = CaptchaIdMap.get(business)!;
  }
  async init() {
    this.TencentCaptcha = await ScriptCenter.load(
      ScriptCenter.menu.TencentCaptcha
    );
    return this.TencentCaptcha;
  }
  show(callback: Function) {
    if (this.TencentCaptcha) {
      this.captcha = new this.TencentCaptcha(this.appId, (ret: any) => {
        if (ret.ret === 0) {
          callback({
            captchaType: "tencent_captcha",
            ticket: ret.ticket,
            randstr: ret.randstr,
            captchaAppId: ret.appid,
          });
        } else {
          callback(null);
        }
      });
      this.captcha.initOpts.themeColor = ThemeColorMap.get(this.business);
      this.captcha.show();
    }
  }
  destory() {
    ScriptCenter.destory(ScriptCenter.menu.TencentCaptcha);
  }
}

class CaptchaManager {
  static captcha: any;
  static errorCaptcha = {
    captchaType: "onload_error",
    ticket: "",
    randstr: "",
    captchaAppId: "",
  };
  static async init(business: CaptchaBusiness) {
    this.captcha = new Captcha(business);
    const captchaObject = await this.captcha.init();
    return captchaObject;
  }
  static async show(callback: Function) {
    try {
      // test the status of user's network connected to the captcha service
      await ScriptCenter.request(ScriptCenter.menu.TencentCaptchaSource);
      this.captcha.show(callback);
    } catch (error) {
      callback(CaptchaManager.errorCaptcha);
    }
  }
  static destory() {
    this.captcha.destory();
  }
}

export default CaptchaManager;
